import { useTranslation } from 'react-i18next';

import { useUserBasic } from '@utils/hooks/useUserBasic';
import { useUserCompany } from '@utils/hooks/useUserCompany';

import { useReactiveVar } from '@apollo/client';
import { authVar } from '@boot/reactiveVariables';

import {
    CompanyInfo,
    Email,
    EmailInfo,
    ProfileDataWrapper,
    StyledIcon,
} from './ProfileData.styled';

interface ProfileDataProps {
    isMobile?: boolean;
}

export const ProfileData = ({ isMobile }: ProfileDataProps) => {
    const { t } = useTranslation();
    const auth = useReactiveVar(authVar);
    const { data: basicUser } = useUserBasic();
    const { data: companyUser } = useUserCompany();

    return (
        <ProfileDataWrapper isMobile={isMobile}>
            <EmailInfo>
                <StyledIcon
                    icon={'SvgProfileCircle24'}
                    isMobile={isMobile}
                    size={24}
                />
                <Email className="htmlToImageIgnore">
                    {auth.isGuest ? t('GUEST_USER') : basicUser?.user.email}
                </Email>
            </EmailInfo>
            <CompanyInfo isMobile={isMobile}>
                {t('LOGGED_IN_TO_TEXT')} {companyUser?.user.tenant?.name}
            </CompanyInfo>
        </ProfileDataWrapper>
    );
};
